module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PHBhdGggZmlsbD0iI0NGRDhEQyIgZD0iTTQwIDlWN2gtOXY1SDE1djExSDh2Mmg3djExaDE2djVoOXYtMmgtN3YtOGg3di0yaC05djVIMTdWMTRoMTR2NWg5di0yaC03Vjl6Ii8+PHBhdGggZmlsbD0iIzAwQkNENCIgZD0iTTQgMjBoOHY4SDR6Ii8+PHBhdGggZD0iTTM2IDE0aDh2OGgtOHptMC0xMGg4djhoLTh6TTIwIDloOHY4aC04em0wIDIyaDh2OGgtOHptMTYgNWg4djhoLTh6bTAtMTBoOHY4aC04eiIgZmlsbD0iIzNGNTFCNSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./assets/images/cloze/genealogy.svg
// module id = 4179
// module chunks = 0